export function SiteHeader({ home = false }: { home?: boolean }) {
  const h = (hash: string) => home ? hash : '/' + hash
  return (
    <header className="flex items-center justify-between px-6 md:px-12 py-6">
      <a href="/" className="flex items-center gap-2 font-display tracking-widest">
        <span className="text-orange text-2xl">[</span>
        <span className="text-blanc text-xl tracking-[0.25em]">PIVOT</span>
        <span className="text-orange text-2xl">]</span>
        <span className="text-acier text-xs tracking-[0.4em] ml-1">MÉDIA</span>
      </a>
      <nav className="flex items-center gap-6 text-xs uppercase tracking-widest text-acier">
        <a href={h('#services')} className="hidden sm:inline hover:text-orange transition-colors">Services</a>
        <a href="/portfolio" className={`hover:text-orange transition-colors ${home ? '' : 'text-blanc'}`}>Portfolio</a>
        <a href={h('#faq')} className="hidden sm:inline hover:text-orange transition-colors">FAQ</a>
        <a href={h('#contact')} className="hidden sm:inline hover:text-orange transition-colors">Contact</a>
        <a href="/login" className="hover:text-orange transition-colors">Espace client</a>
      </nav>
    </header>
  )
}

export function SiteFooter() {
  return (
    <footer className="px-6 md:px-12 py-8 border-t border-white/5 text-center text-acier text-xs tracking-widest">
      © {new Date().getFullYear()} Pivot Média · Production vidéo industrielle · Québec
    </footer>
  )
}
